/* eslint-disable @typescript-eslint/ban-types */
import React from 'react'
import { useStyles } from '../UserManagement/UserProfileStyles'
import { Box, Button, Divider } from '@mui/material'
import { Check as CheckIcon, Clear as ClearIcon } from '@mui/icons-material'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

export default function DeleteDialog({ open, onClose, header, handleSubmit }) {
  const classes = useStyles()

  return (
    <Box className={`${classes.mt} , ${classes.mb}`}>
      <Dialog
        fullWidth
        maxWidth="sm"
        id="hello"
        classes={{ paper: classes.dialogHeight }}
        open={open}
        onClose={onClose}
      >
        <DialogTitle className={classes.dialogTitle}>{header}</DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText className={classes.dialogContent}>
            {header === 'Delete Holiday' && `Are you sure you want to delete this holiday?`}
            {header === 'Delete Procedure Code' && `Are you sure you want to delete this procedure code?`}
            {header === 'Unassign' && `Are you sure want to Unassign this case? Click Yes to Continue or No to Cancel.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.buttonActions}>
          <Button
            className={`${classes.btn} ${classes.buttonMargin}`}
            onClick={(event) => handleSubmit(event)}
            endIcon={<CheckIcon />}
          >
            Yes
          </Button>
          <Button onClick={onClose} variant="outlined" className={classes.buttonMargin} endIcon={<ClearIcon />}>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}
